import { defineMessages } from '@jutro/locale';

export default defineMessages({
    policiesNeedYourAttention: {
        id: 'ml.policychange.MLModalWithAlerts.UnderlyingPolicy.Policies marked with a (!) need your attention',
        defaultMessage: 'Policies marked with a (!) need your attention. Please click the edit link and fill out all required fields.'
    },
    addPolicy: {
        id: 'ml.policychange.MLModalWithAlerts.UnderlyingPolicy.ADD POLICY',
        defaultMessage: 'ADD POLICY'
    },
    businessActivitiesNeedYourAttention: {
        id: 'ml.policychange.MLModalWithAlerts.BusinessActivity.Business activities marked with a (!) need your attention',
        defaultMessage: 'Business activities marked with a (!) need your attention.'
    },
    clickEditLink: {
        id: 'ml.policychange.MLModalWithAlerts.BusinessActivity.Please click the edit link and fill out all the required fields.',
        defaultMessage: 'Please click the edit link and fill out all the required fields.'
    },
    addBusinessActivity: {
        id: 'ml.policychange.MLModalWithAlerts.BusinessActivity.ADD BUSINESS ACTIVITY',
        defaultMessage: 'ADD BUSINESS ACTIVITY'
    },
    vehiclesNeedYourAttention: {
        id: 'ml.policychange.MLModalWithAlerts.PUPVehicle.Vehicles marked with a (!) need your attention',
        defaultMessage: 'Vehicles marked with a (!) need your attention.'
    },
    clickEditAndFillOutRequiredFields: {
        id: 'ml.policychange.MLModalWithAlerts.PUPVehicle.Please click the edit link and fill out all the required fields',
        defaultMessage: 'Please click the edit link and fill out all the required fields.',
    },
    addVehicle: {
        id: 'ml.policychange.MLModalWithAlerts.PUPVehicle.ADD VEHICLE',
        defaultMessage: 'ADD VEHICLE'
    },
    addLocation: {
        id: 'ml.policychange.MLModalWithAlerts.Location.ADD LOCATION',
        defaultMessage: 'ADD LOCATION'
    },
});
